import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AlunoComAnosLetivos } from '../models/portal.models';

interface AlunoComCor extends AlunoComAnosLetivos {
  cor?: string;
  borderColor?: string;
}

@Component({
  selector: 'app-aluno-selector',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './aluno-selector.html',
  styleUrls: ['./aluno-selector.scss'] 
})
export class AlunoSelectorComponent {
  @Input() set alunos(value: AlunoComAnosLetivos[]) {
    this._alunos = value.map((aluno, index) => {
      const cores = ['#0fa3ad', '#f39c12', '#9b59b6'];
      const borderCores = ['#0fa3ad', '#f39c12', '#9b59b6'];
      return {
        ...aluno,
        cor: cores[index % cores.length],
        borderColor: borderCores[index % borderCores.length]
      } as AlunoComCor;
    });
  }
  get alunos(): AlunoComCor[] { 
    return this._alunos;
  }
  private _alunos: AlunoComCor[] = [];

  @Input() alunoSelecionado: AlunoComAnosLetivos | null = null;
  @Output() alunoSelecionado$ = new EventEmitter<AlunoComAnosLetivos>();

  selecionarAluno(aluno: AlunoComAnosLetivos) {
    this.alunoSelecionado$.emit(aluno);
  }

  getAlunoStyle(aluno: AlunoComCor) {  // ← Tipagem melhorada
    return {};
  }

  getIconStyle(aluno: AlunoComCor) {  // ← Tipagem melhorada
    if (this.alunoSelecionado?.id === aluno.id) {
      return {};
    }
    
    return {
      'background-color': '#ededed',
      'color': '#282d36'
    };
  }
}
